import {Swiper, SwiperSlide, useSwiper} from 'swiper/react';
import 'swiper/css';
import './SliderTest.css';
import Panel from "./Panel";
import {useState} from "react";

export default function SliderTest({test, data, allAnswers,setSlideNumber,slideNumber,isPassed,rightObj}) {
    const [activeSlide,setActiveSlide] = useState(0)
    return (
            <Swiper
                style={{
                    display: "flex",
                    flexDirection: "column-reverse",
                }}
                spaceBetween={50}
                slidesPerView={1}
                onSlideChange={(swiper) => {
                    console.log('slide change', swiper.activeIndex)
                    setActiveSlide(swiper.activeIndex)
                }}
                onSwiper={(swiper) => console.log(swiper)}
                allowTouchMove={false}
            >

                {data?.map((slide, idx) =>
                    <SwiperSlide key={`slide-${idx}`}>{slide}</SwiperSlide>
                )}

                 <div className="slider-cool">
                     {data?.length>1 && <SlidePrevButton setSlideNumber={setSlideNumber}/>}
                    <Panel test={test}
                           activeSlide={activeSlide}
                           answers={allAnswers}
                           setSlideNumber={setSlideNumber}
                           slideNumber={slideNumber}
                           isPassed={isPassed}
                           rightObj={rightObj}
                    />
                     {data?.length>1 && <SlideNextButton setSlideNumber={setSlideNumber}/>}
                </div>
            </Swiper>
    );
}

function SlideNextButton({setSlideNumber}) {
    const swiper = useSwiper();
    return (
        <div className="general-slider-button general-slider-button_next" onClick={() => {
            swiper.slideNext();
            setSlideNumber(1)
        }}><span
            className='general-slider-button-ico general-slider-ico_next'> </span></div>
    );
}

function SlidePrevButton({setSlideNumber}) {
    const swiper = useSwiper();
    return (
        <div className="general-slider-button general-slider-button_prev" onClick={() => {
            swiper.slidePrev()
            setSlideNumber(1)
        }}><span
            className='general-slider-button-ico general-slider-ico_prev'> </span></div>
    );
}
